import { useEffect } from 'react';
import { apiClient } from '../api/client';

/**
 * Хук для отслеживания статуса оплаты через Telegram
 * Автоматически разлогинивает пользователя после успешной связки аккаунтов
 */
export const useTelegramPaymentWatcher = () => {
  useEffect(() => {
    const token = localStorage.getItem('telegram_payment_token');
    
    if (!token) {
      return; // Нет активного платежа
    }
    
    console.log('🔍 Checking Telegram payment status...');
    
    // Проверяем статус каждые 3 секунды
    const interval = setInterval(async () => {
      try {
        const status = await apiClient.checkTelegramPaymentStatus(token);
        
        if (status.account_linked) {
          console.log('✅ Аккаунты связаны! Разлогиниваем пользователя...');
          
          // Очищаем все данные
          localStorage.removeItem('telegram_payment_token');
          localStorage.removeItem('auth_token');
          localStorage.clear();
          
          // Показываем сообщение и перезагружаем
          alert(
            '✅ Оплата успешна!\n\n' +
            'Ваш аккаунт был связан с Telegram.\n' +
            'Пожалуйста, войдите заново для продолжения работы.'
          );
          
          // Перезагружаем страницу
          window.location.href = '/';
          
          clearInterval(interval);
        }
      } catch (error) {
        console.error('Error checking payment status:', error);
        // При ошибке продолжаем проверять
      }
    }, 3000);
    
    // Очищаем интервал при размонтировании
    return () => clearInterval(interval);
  }, []);
};

